import { ApigeeDAO } from './apigee.dao';
import { IAppConfig } from '../../store/interfaces/IAppConfig';
import { Observable } from 'rxjs/Observable';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '../config';
import { HotelDataValidator } from './validators/data.validators';
import { DefaultRetryHandler } from './handlers/retry.handlers';
import { HttpClient } from '@angular/common/http';
import { LogService } from '../services/logging.service';
import { CookieService } from 'ngx-cookie-service';

const CLASS_NAME = 'HotelDao';

@Injectable()
export class HotelDao extends ApigeeDAO {
  constructor(http: HttpClient, @Inject(APP_CONFIG) appConfig: IAppConfig, log: LogService, cookieService: CookieService) {
    super(CLASS_NAME, http, appConfig, appConfig.hotelDetailDAO, new DefaultRetryHandler(), new HotelDataValidator(), log, cookieService);
  }

  public getHotel(hotelMnemonic): Observable<any> {
    const url = this.daoConfig.url.replace('{hotelMnemonic}', hotelMnemonic);
    return this.doGet(url);
  };
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/daos/hotel.dao.ts